import { callUIAPI, isSuccessCode } from './apiUtils';
import { METHOD_GET, SERVER_URL } from './apiUtilsConstants';

export const checkSpeechToTextEnabled = async () => {
  try {
    const response = await callUIAPI('speech-to-text/check', {}, METHOD_GET, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('speechApiUtils.checkSpeechToTextEnabled - error:', error);
    return { enabled: false };
  }
};

export const transcribeAudio = async (audioBlob, mimeType, options = {}) => {
  console.log(
    'speechApiUtils.transcribeAudio - blob size:',
    audioBlob.size,
    'mimeType:',
    mimeType
  );

  const extension = mimeType.includes('webm') ? 'webm' : mimeType.includes('ogg') ? 'ogg' : 'wav';
  const formData = new FormData();
  formData.append('audio', audioBlob, `recording.${extension}`);

  if (options.language) {
    formData.append('language', options.language);
  }

  try {
    const response = await fetch(`${SERVER_URL}/api/ui/speech-to-text/transcribe`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      const failure = new Error(errData.message || `Transcription failed (${response.status})`);
      failure.errorCode = errData.errorCode;
      throw failure;
    }

    const data = await response.json();
    console.log('speechApiUtils.transcribeAudio - transcription length:', data.text?.length);
    return data;
  } catch (error) {
    console.error('speechApiUtils.transcribeAudio - error:', error);
    throw error;
  }
};